exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".c-text {\n  color: #333;\n  background-color: #fff;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n  padding: 2px;\n  font-size: 3em; }\n\n.c-text:empty {\n  display: none; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/content-types/text/text.scss
// module id = 438
// module chunks = 0